import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { InfoBlockModule } from '@commons/info-block/info-block.component';
import { PaginationModule } from '@commons/pagination/pagination.component';
import { QuicklinkSharedModule } from '@core/ngx-quicklink.shared.module';
import { SearchEngineModule } from '@domains/search-engine/search-engine/search-engine.component';
import { YouthInfoCenterCardModule } from '@domains/youth-info-center/card/youth-info-center-card.component';
import { YouthInfoCenterHeroModule } from '@domains/youth-info-center/hero/hero.component';
import { YouthInfoCenterListComponent } from '@features/youth-info-center/youth-info-center-list/youth-info-center-list.component';
import { NgxSkeletonLoaderModule } from 'ngx-skeleton-loader';

const routes: Routes = [
  {
    path: '',
    component: YouthInfoCenterListComponent,
  },
];

@NgModule({
  declarations: [YouthInfoCenterListComponent],
  imports: [
    CommonModule,
    QuicklinkSharedModule,
    RouterModule.forChild(routes),
    YouthInfoCenterHeroModule,
    YouthInfoCenterCardModule,
    SearchEngineModule,
    PaginationModule,
    NgxSkeletonLoaderModule,
    InfoBlockModule,
    PaginationModule,
    NgxSkeletonLoaderModule,
    InfoBlockModule,
  ],
})
export class YouthInfoCenterModule {}
